function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import withStyles from 'isomorphic-style-loader/withStyles';
import forEach from 'lodash/forEach';
import get from 'lodash/get';
import isEmpty from 'lodash/isEmpty';
import keysIn from 'lodash/keysIn';
import last from 'lodash/last';
import map from 'lodash/map';
import mapKeys from 'lodash/mapKeys';
import times from 'lodash/times';
import filter from 'lodash/filter';
import valuesIn from 'lodash/valuesIn';
import startsWith from 'lodash/startsWith';
import compact from 'lodash/compact';
import { AppContext } from 'context';
import Validator from 'libs/Validator';
import { compactObject } from 'helpers/transformers';
import Form from 'components/Form';
import FormGroup from 'components/Form/FormGroup';
import Input from 'components/Form/Input';
import Button from 'components/Form/Button';
import App from 'modules/App';
import * as actions from '../../actions';
import * as constants from '../../constants';
import messages from '../../messages';
import styles from './InviteFamilyMembersForm.pcss';
import validatorRules from './validatorRules.json';
var _React_PureComponent;
class InviteFamilyMembersForm extends (_React_PureComponent = React.PureComponent) {
    onAddPerson(idx) {
        this.props.onSetFormValue({
            id: idx,
            value: {}
        });
    }
    onSetValue(idx, input) {
        const { id, value } = input;
        const personValues = _object_spread_props(_object_spread({}, get(this.props.formValues, [
            'values',
            idx
        ], {})), {
            [id]: value
        });
        this.props.onSetFormValue({
            id: idx,
            value: personValues
        });
    }
    onSubmit(checkOnly = false) {
        const personsValues = get(this.props.formValues, 'values');
        const compactedPersonsValues = compactObject(personsValues);
        const formErrors = {};
        const invitees = [];
        let hasErrors = false;
        forEach(compactedPersonsValues, (personValues, idx)=>{
            const values = mapKeys(personValues, (v, k)=>k.replace(`person${idx}.`, ''));
            if (!isEmpty(values)) {
                const { validatedValues, errors } = Validator.run(values, validatorRules);
                invitees.push(validatedValues);
                hasErrors = hasErrors || !!errors;
                if (errors) {
                    const fieldErrors = mapKeys(errors, (v, k)=>`person${idx}.${k}`);
                    formErrors[idx] = fieldErrors;
                } else {
                    formErrors[idx] = undefined;
                }
            }
        });
        this.props.onFormErrors(formErrors);
        if (!hasErrors && !checkOnly) {
            this.props.onSubmit(invitees);
        }
    }
    get isDisabled() {
        const required = filter(valuesIn(validatorRules), (rule)=>startsWith(rule, 'required')).length;
        const invitees = compactObject(get(this.props.formValues, 'values'));
        if (isEmpty(invitees)) {
            return true;
        }
        let isDisabled = false;
        forEach(invitees, (invitee)=>{
            const values = compact(valuesIn(invitee));
            if (values.length !== required) {
                isDisabled = true;
                return false;
            }
            return true;
        });
        return isDisabled;
    }
    renderSubmitBtn() {
        const { isDisabled } = this;
        let isDisabledClickable = false;
        if (isDisabled) {
            const personsValues = get(this.props.formValues, 'values');
            const compactedPersonsValues = compactObject(personsValues);
            const formErrors = get(this.props.formValues, 'errors', {});
            isDisabledClickable = !(isEmpty(compactedPersonsValues) && isEmpty(formErrors));
        }
        return /*#__PURE__*/ _jsx(Button, {
            type: "submit",
            styleModifier: "primary",
            labelMessage: messages.buttons.inviteFamilyMembers,
            isDisabled: isDisabled,
            isInProgress: this.props.isInProgress,
            className: "btn--block btn--filled",
            onClickDisabled: isDisabledClickable ? ()=>this.onSubmit(true) : undefined
        });
    }
    renderPerson(idx) {
        const personValues = {
            values: get(this.props.formValues, [
                'values',
                idx
            ], {}),
            errors: get(this.props.formValues, [
                'errors',
                idx
            ])
        };
        return /*#__PURE__*/ _jsxs("div", {
            children: [
                /*#__PURE__*/ _jsx("h3", {
                    className: "text--h3 text--bold mt-3 mb-4",
                    children: /*#__PURE__*/ _jsx(FormattedMessage, _object_spread_props(_object_spread({}, messages.headers.person), {
                        values: {
                            number: +idx + 1
                        }
                    }))
                }),
                /*#__PURE__*/ _jsxs("div", {
                    className: "row",
                    children: [
                        /*#__PURE__*/ _jsx("div", {
                            className: "col-6",
                            children: /*#__PURE__*/ _jsx(FormGroup, {
                                id: `person${idx}.inviteeFirstName`,
                                labelMessage: messages.labels.firstName,
                                formValues: personValues,
                                children: /*#__PURE__*/ _jsx(Input, {
                                    placeholder: messages.placeholders.firstName,
                                    onChange: (input)=>this.onSetValue(idx, input)
                                })
                            })
                        }),
                        /*#__PURE__*/ _jsx("div", {
                            className: "col-6",
                            children: /*#__PURE__*/ _jsx(FormGroup, {
                                id: `person${idx}.inviteeLastName`,
                                labelMessage: messages.labels.lastName,
                                formValues: personValues,
                                children: /*#__PURE__*/ _jsx(Input, {
                                    placeholder: messages.placeholders.lastName,
                                    onChange: (input)=>this.onSetValue(idx, input)
                                })
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ _jsx(FormGroup, {
                    id: `person${idx}.inviteeEmailAddress`,
                    labelMessage: messages.labels.email,
                    formValues: personValues,
                    children: /*#__PURE__*/ _jsx(Input, {
                        placeholder: messages.placeholders.email,
                        onChange: (input)=>this.onSetValue(idx, input)
                    })
                })
            ]
        }, `person${idx}`);
    }
    render() {
        const personsIdxs = keysIn(get(this.props.formValues, 'values', {}));
        return /*#__PURE__*/ _jsxs(Form, {
            onSubmit: ()=>this.onSubmit(),
            children: [
                map(personsIdxs, (idx)=>this.renderPerson(idx)),
                /*#__PURE__*/ _jsx(Button, {
                    labelMessage: _object_spread({}, messages.buttons.addAnotherPerson),
                    styleModifier: "transparent",
                    className: styles.addAnotherPersonBtn,
                    onClick: ()=>this.onAddPerson(+last(personsIdxs) + 1)
                }),
                this.renderSubmitBtn()
            ]
        });
    }
    constructor(props){
        super(props);
        if (isEmpty(props.formValues)) times(this.props.persons, (n)=>this.onAddPerson(n));
    }
}
_define_property(InviteFamilyMembersForm, "contextType", AppContext);
_define_property(InviteFamilyMembersForm, "propTypes", {
    // Explicit props
    persons: PropTypes.number,
    isInProgress: PropTypes.bool,
    // Implicit props
    formValues: PropTypes.object,
    // Implicit actions
    onSubmit: PropTypes.func,
    onSetFormValue: PropTypes.func,
    onFormProcessing: PropTypes.func.isRequired,
    onFormErrors: PropTypes.func.isRequired
});
_define_property(InviteFamilyMembersForm, "defaultProps", {
    persons: 1
});
const mapStateToProps = (state)=>({
        formValues: App.selectors.formSelector(constants.INVITE_FAMILY_MEMBERS_FORM)(state)
    });
const mapDispatchToProps = (dispatch)=>{
    const formName = constants.INVITE_FAMILY_MEMBERS_FORM;
    return {
        onSubmit: (invitees)=>dispatch(actions.inviteFamilyMembers(invitees)),
        onSetFormValue: (input)=>dispatch(App.actions.setFormValue(formName, input)),
        onFormErrors: (errors)=>dispatch(App.actions.setFormErrors(formName, errors)),
        onFormProcessing: ()=>dispatch(App.actions.startFormProcessing(formName)),
        onClearForm: ()=>dispatch(App.actions.clearForm(formName))
    };
};
const ConnectedInviteFamilyMembersForm = connect(mapStateToProps, mapDispatchToProps)(InviteFamilyMembersForm);
export default withStyles(styles)(ConnectedInviteFamilyMembersForm);
